import { locationAgreedAtom, userLatLonAtom } from '@atoms/locationAtoms';
import Button from '@components/Button';
import Map from '@components/Map';
import styled from '@emotion/styled';
import usePrevState from '@hooks/usePrevState';
import useProject from '@hooks/useProject';
import { ShopInMapRow } from '@models/shop';
import { useFlow } from '@stackflow/react';
import { useAtom, useAtomValue } from 'jotai';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useOnBoundChange from './hooks/useOnBoundChange';

interface Props {
    markers?: MarkerProps[];
    isOrder?: boolean;
    next?: string;
    shops?: ShopInMapRow[];
}

function ShopMap({ markers, isOrder, shops }:Props) {
    const { push } = useFlow();
    const { t } = useTranslation('shopList');
    const shopIds = useMemo(
        () => shops?.map((it) => it.id)
            .sort()
            .join('-'),
        [shops],
    );
    const prevShopId = usePrevState(shopIds);

    const handleMarkerClick = (
        id?: string,
        lat?: number,
        lng?: number,
    ) => {
        if (isOrder) {
            push('ShopLocationBottomSheet', {
                shopId: id!,
                lat,
                lng,
            });
        } else {
            push('ShopDetailBottomSheet', {
                shopId: id!,
            });
        }
    };
    const onBoundChange = useOnBoundChange();
    const [location, setLocation] = useAtom(userLatLonAtom);
    const locationAgreed = useAtomValue(locationAgreedAtom);
    const project = useProject();
    const defaultLocation = { lat: project?.lat || 37.4811291019439, lng: project?.lon || 126.895303784633 };

    const myLocation = (location.lat !== 0 && locationAgreed) ? {
        lat: location.lat,
        lng: location.lon,
    } : defaultLocation;
    const [center, setCenter] = useState(myLocation);
    // 매장 변경 시 가장 가까운 매장의 위치로 설정
    useEffect(() => {
        if (shopIds === prevShopId) {
            return;
        }
        const firstShop = shops?.[0];
        if (firstShop) {
            setCenter({
                lat: firstShop.lat,
                lng: firstShop.lon,
            });
        }
    }, [shops, shopIds, prevShopId]);
    return (
        <Container>
            <Map center={center}
                myLocation={myLocation}
                height={320}
                onMarkerClick={handleMarkerClick}
                onBoundChange={onBoundChange}
                showMyLocation={locationAgreed}
                markers={markers} />
            {(!locationAgreed) && (
                <AgreeButton
                    onClick={() => push('AccountSettingActivity', {})}
                    size='medium'>
                    {t('map.locationConsent')}
                </AgreeButton>
            )}
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    width: 100%;
    height: 320px;
    max-height: 320px;
    min-height: 320px;
    position: relative;
    justify-content: center;
`;

const AgreeButton = styled(Button)`
    height: 36px !important;
    padding: 6px 12px !important;
    border-radius: 15px;
    position: absolute;
    bottom: 12px;
`;

export default ShopMap;
